import { SSPA } from '../constants/sspa'
import { OverlayService } from './overlay.service'

export class SidenavService {
  private static sidenavService: SidenavService

  private constructor() {
  }

  static singleton(): SidenavService {
    if (!SidenavService.sidenavService) {
      SidenavService.sidenavService = new SidenavService()
    }
    return SidenavService.sidenavService
  }

  toggle() {
    if (window.innerWidth > SSPA.mobileWindowWidth) return
    const sidenav: HTMLElement = document.querySelector(SSPA.launcherSidenav)
    sidenav.classList.toggle('show')
    OverlayService.singleton().toggle()
  }

  close() {
    const sidenav: HTMLElement = document.querySelector(SSPA.launcherSidenav)
    sidenav.classList.remove('show')
  }
}
